module.exports = __webpack_public_path__ + "img/book-image-top.135282ff.png";